import React, { useState, useEffect } from "react";
import { Select, Button } from "antd";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import moment from "dayjs";
/**
 * ======== UI组件
 */
import Title from "../components/Title";
import SubTitle from "../components/Title/subTitle";
import Tab from "../components/Tab";
import CommonlyChart from "../components/charts";
import Gauge from "../components/Gauge";
import ScrollNumber from "../components/ScrollNumber";
import TabList from "./TabList";
/**
 * ====== redux
 */
import { setScreenInfo } from "@store/actions/common";

/**
 * ======== api
 */
import API from "../api/screen";

import "./right.scss";

const Index = withRouter(
  ({ allMeters, dispatch, showRight, screenInfo, history }) => {
    const [stationList, setStationList] = useState([]); //供选择的 电站列表
    const [data, setData] = useState({}); // 设计 生产指标数据
    const [percent, setPercent] = useState(0); // 今日生产/生产指标的比例

    const [shuiliang_option, setShuiliang_option] = useState({}); //进出水水量统计
    const [inOrOutActive, setInOrOutActive] = useState(0); //进出水水量/能耗统计-0 - 进出水 1 - 能耗 ,
    const [reportTypeActive, setReportTypeActive] = useState(0); // 进出水水量/能耗统计 ---0 - 日报表 1 - 月报表 2 - 年报表
    const [interval_staion, setInterval_staion] = useState(""); // 固定时30分钟刷新一次

    const [pointData, setPointData] = useState({}); //出水质实时数据
    const [pointInData, setPointInData] = useState({}); //进水质实时数据

    useEffect(() => {
      let stationList = [];
      screenInfo.stationList.map((item) => {
        stationList.push({
          label: item.aliasName,
          value: item.id,
        });
      });
      setStationList(stationList);
    }, [screenInfo.stationList]);

    useEffect(() => {
      screenInfo.stationId && stationDesignOrProdQuota();
      screenInfo.stationId && stationOutWaterQuality();
      screenInfo.stationId && handleWaterAndDnb();
    }, [screenInfo.stationId]);

    // 固定时1分钟刷新一次
    useEffect(() => {
      if (screenInfo.clickStationId) {
        // 点击固定某个电站
        let i = setInterval(
          () => {
            screenInfo.stationId && stationDesignOrProdQuota();
            screenInfo.stationId && stationOutWaterQuality();
            screenInfo.stationId && handleWaterAndDnb();
          },
          1 * 60 * 1000,
        );
        setInterval_staion(i);
        return () => {
          clearInterval(i);
        };
      } else {
        //点击了监控关闭， 清除定时器
        clearInterval(interval_staion);
      }
    }, [screenInfo.clickStationId]);

    useEffect(() => {
      screenInfo.stationId && handleWaterAndDnb();
    }, [inOrOutActive, reportTypeActive]);

    //生产指标
    const stationDesignOrProdQuota = () => {
      API.stationDesignOrProdQuota({ stationId: screenInfo.stationId }).then(
        (res) => {
          if (res.status == 0) {
            setData(res.data);
            const percent = res.data["designQuota"]
              ? ((res.data["todayProd"] / res.data["designQuota"]) * 100).toFixed(
                  2,
                )
              : 0;
            setPercent(percent);
          }
        },
      );
    };
    // 厂站出水水质实时数据
    const stationOutWaterQuality = () => {
      API.stationOutWaterQuality({ stationId: screenInfo.stationId }).then(
        (res) => {
          if (res.status == 0) {
            const inData = transcod(res.data.in);
            setPointData(transcod(res.data.out));
            setPointInData(inData);
          }
        },
      );
    };
    const transcod = (values) => {
      let data = {};
      values &&
        values.map((item) => {
          if (item.pointValue == "PH") {
            // ph
            const a = item.qualifiedValue.indexOf("-");
            let min = item.qualifiedValue.substring(0, a) * 1;
            let max = item.qualifiedValue.substring(a + 1) * 1;
            let limit_min =
              (item.qualifiedValue.substring(0, a) / 14).toFixed(2) * 1;
            let limit_max =
              (item.qualifiedValue.substring(a + 1) / 14).toFixed(2) * 1;
            let limit_middle = (limit_max - limit_min) / 2 + limit_min;
            data[item.pointValue] = {
              section: [
                { beginNum: 0, endNum: limit_min },
                { beginNum: limit_min, endNum: limit_middle },
                { beginNum: limit_middle, endNum: limit_max },
                { beginNum: limit_max, endNum: 1 },
              ],
              // value: 8 / 14,
              value: item.val && item.val / 14,
              value_show: item.val && item.val * 1,
              warning:
                ((item.val || item.val === 0) &&
                  item.val * 1 >= min &&
                  item.val * 1 <= max) ||
                item.val === null
                  ? false
                  : true,
            };
          } else {
            const qualifiedValue = item.qualifiedValue
              ? item.qualifiedValue
              : item.val;
            const max = qualifiedValue * 1.25; //最大值为标准值的1.25倍
            const middle = qualifiedValue / max; //计算 标准值对应的中间值
            data[item.pointValue] = {
              section: [
                { beginNum: 0, endNum: isNaN(middle) ? 0 : middle },
                { beginNum: isNaN(middle) ? 0 : middle, endNum: 1 },
              ],
              // value: 60 / max,
              value: item.val && item.val / max,
              value_show: item.val && item.val * 1,
              warning: item.val * 1 <= qualifiedValue * 1 ? false : true,
            };
          }
        });
      return data;
    };
    // 进出水水量/能耗统计
    const handleWaterAndDnb = () => {
      let reportType = inOrOutActive ? 2 : reportTypeActive + 1;
      API.handleWaterAndDnb({
        inOrOut: inOrOutActive + 1,
        reportType: reportType,
        stationId: screenInfo.stationId,
      }).then((res) => {
        if (res.status == 0) {
          // { name: '进水', type: 'line', data: [] },
          let series1 = [{ name: "出水", type: "line", data }];
          let series2 = [{ name: "能耗", type: "line", data: [] }];
          let _in = []; //进水
          let _out = []; //出水
          let _nenghao = []; //能耗
          let day = [];
          let format = "HH:mm";
          if (reportTypeActive == 1) {
            //月
            format = "MM-DD";
          } else if (reportTypeActive == 2) {
            //年
            format = "YYYY-MM";
          }
          if (inOrOutActive) {
            format = "MM";
          }
          Object.keys(res.data).map((item) => {
            res.data[item].map((iitem) => {
              day.push(moment(iitem.createTime).format(format));
              if (iitem.inOrOut == 1) {
                _in.push((iitem.value * 1).toFixed(3));
              }
              if (iitem.inOrOut == 2) {
                _out.push((iitem.value * 1).toFixed(3));
              }
              if (iitem.inOrOut == 3) {
                _nenghao.push((iitem.value * 1).toFixed(3));
              }
            });
          });
          let xAxis = day.filter((x, index, self) => self.indexOf(x) === index);
          if (inOrOutActive == 0) {
            //进水出水
            // series1[0].data = _in;
            series1[0].data = _out;
            // '进水',
            getShuiliang_option(xAxis, series1, ["出水"]);
          } else {
            series2[0].data = _nenghao;
            getShuiliang_option(xAxis, series2, ["能耗"]);
          }
        }
      });
    };

    const getShuiliang_option = (xAxis, seriesData, legendData) => {
      let _seriesData = [];
      seriesData.map((item) => {
        _seriesData.push({
          ...item,
          lineStyle: {
            width: 2,
          },
        });
      });
      let option = {
        color: ["#1AC8FF", "#06FFA5"],
        title: {
          text: "单位：m³",
          textStyle: {
            color: "rgba(255, 255, 255, 0.85)",
            fontSize: 12,
          },
        },
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: legendData,
          right: "20",
          icon: "rect",
          itemWidth: 30,
          itemHeight: 4,
        },
        grid: {
          show: true,
          top: "16%",
          left: "3%",
          right: "3%",
          bottom: "1%",
          containLabel: true,
          borderColor: "rgba(0, 200, 255, 0.45)",
          borderWidth: 2,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            color: "rgba(255, 255, 255, 0.65)",
          },
          data: xAxis,
        },
        yAxis: {
          type: "value",
          axisLabel: {
            color: "rgba(255, 255, 255, 0.65)",
          },
          splitLine: {
            show: true,
            lineStyle: {
              width: 1,
              color: "rgba(0, 201, 255, 0.25)",
            },
          },
        },
        series: _seriesData || [
          {
            name: "进水",
            type: "line",
            data: [120, 132, 101, 134, 90, 230, 210],
          },
          {
            name: "出水",
            type: "line",
            data: [220, 182, 191, 234, 290, 330, 310],
          },
        ],
      };
      setShuiliang_option(option);
    };

    const setActive2 = (index) => {
      setInOrOutActive(index);
    };
    const setActive3 = (index) => {
      setReportTypeActive(index);
    };

    const changeStation = (value) => {
      let stationName = "";
      screenInfo.stationList.map((item) => {
        if (item.id == value) {
          stationName = item.aliasName;
        }
      });
      dispatch(
        setScreenInfo({
          ...screenInfo,
          stationId: value,
          clickStationId: value,
          stationName,
        }),
      );
    };

    const gotoProgress = () => {
      history.push(
        "/stationManagement/factoryProgress?id=" + screenInfo.stationId,
      );
    };

    return (
      <div className="left-wrap relative right_wrap">
        <div className="relative">
          <Title
            title={
              <Select
                options={stationList}
                value={screenInfo.stationId}
                onChange={changeStation}
                style={{ width: 120 }}
              ></Select>
            }
          />
          <Button
            type="primary"
            onClick={gotoProgress}
            style={{ position: "absolute", right: 0, top: 10, zIndex: 99 }}
          >
            工艺流程
          </Button>
          <div className="mt24 block_item zhibiao_wrapper">
            <SubTitle title="厂站设计指标/产水指标（天）" />
            <div className="statisc flex alignItemCenter mt24">
              <div className="relative">
                <div className="round_01">
                  <div className="round_02"></div>
                  <div className="round_text">
                    <div className="round_text_label">产水指标</div>
                    <div className="round_text_value numberFont">
                      {data["designQuota"]}m³/d
                    </div>
                    <div className="round_text_percent numberFont">
                      {percent}%
                    </div>
                  </div>
                </div>
              </div>
              <div className="flexColumn ml32">
                <div className="flex">
                  <div className="">
                    <div className="text1">今日水量</div>
                    <div className="font24 numberFont flex alignItemEnd">
                      {data["todayProd"] !== null ? (
                        <ScrollNumber data={data["todayProd"]}></ScrollNumber>
                      ) : (
                        "--"
                      )}
                      <span
                        className="text1"
                        style={{ lineHeight: "34px", marginLeft: 5 }}
                      >
                        m³
                      </span>
                    </div>
                  </div>
                  <div className="ml64">
                    <div className="text1">今日电耗</div>
                    <div className="font24 numberFont flex alignItemEnd">
                      {data["todayDnb"] !== null ? (
                        <ScrollNumber data={data["todayDnb"]}></ScrollNumber>
                      ) : (
                        "--"
                      )}
                      <span
                        className="text1"
                        style={{ lineHeight: "34px", marginLeft: 5 }}
                      >
                        kwh
                      </span>
                    </div>
                  </div>
                </div>
                <div className="flex alignItemCenter">
                  <div className="font13 color65">设计指标</div>
                  <div className="font15 blod ml8">{data["designQuota"]}</div>
                  <div className="font13 color65 ml8">m³/d</div>
                </div>
              </div>
            </div>
            {/* 统计列表      */}
            <TabList />
          </div>
        </div>

        <div className="mt10">
          <SubTitle
            style={{ marginBottom: "5px" }}
            title="厂站进水水质实时数据"
          />
          <div className="flex" style={{ height: 100 }}>
            {Object.keys(pointInData).map(
              (item, index) =>
                pointInData[item] && (
                  <Gauge
                    key={index + 1}
                    data={pointInData[item]}
                    loading={false}
                    title={item}
                    width={`${100 / Object.keys(pointInData).length}%`}
                  />
                ),
            )}
          </div>
        </div>

        <div className="mt10">
          <SubTitle
            style={{ marginBottom: "5px" }}
            title="厂站出水水质实时数据"
          />
          <div className="flex" style={{ height: 100 }}>
            {Object.keys(pointData).map(
              (item, index) =>
                pointData[item] && (
                  <Gauge
                    key={index + 1}
                    data={pointData[item]}
                    loading={false}
                    title={item}
                    width={`${100 / Object.keys(pointData).length}%`}
                  />
                ),
            )}
          </div>
        </div>

        <div className="mt10">
          <SubTitle
            style={{ marginBottom: "5px" }}
            title={
              <Tab
                data={["出水水量统计", "能耗统计"]}
                activeClass="tab_shuiliang_active"
                onChange={setActive2}
              />
            }
          >
            <Tab
              data={inOrOutActive ? ["月"] : ["日", "月", "年"]}
              onChange={setActive3}
            />
          </SubTitle>
          <div className="mt10">
            <CommonlyChart
              option={shuiliang_option}
              height={197}
            ></CommonlyChart>
          </div>
        </div>
      </div>
    );
  },
);

const mapStateToProps = (state) => {
  return {
    ...state.Common,
  };
};
const RightComp = connect(mapStateToProps)(Index);
RightComp.displayName = "RightComp";

export default RightComp;
